import { EventEmitter, Injectable } from '@angular/core';
import { Layer } from '../../../../interface/map.interface';
import { Map } from 'ol';
import { ReplaySubject, Subject } from 'rxjs';
import { AddLayerOptions } from '../../../../interface/geobi/layer.interface';

import { UpdateLayerStyleInterface } from 'src/app/interface/geobi/layer.interface';
import { debounce } from '@syncfusion/ej2-base';
import { ActivatedRoute } from '@angular/router';
import { MapService } from 'src/app/services/map.service';
import { EventEmitterAsyncResourceOptions } from 'events';

@Injectable({
  providedIn: 'root',
})
export class MapSideBarService {
  selectedLayer: any;
  styleMode = false;
  editMode = false;
  editFeature = false;
  deleteFeature = false;
  layerTable = false;
  tableChanged = false;

  filterMode = false;
  searchFeatureMode = false;
  mapFrame: Map;
  layers_list: any;
  repositoriesMode = false;
  clearLayerSelectionSubject = new Subject<void>();
  clearLayerSelection$ = this.clearLayerSelectionSubject.asObservable();

  selectedMapFeature: EventEmitter<any> = new EventEmitter();
  openLayerTableEvent: EventEmitter<boolean> = new EventEmitter();
  saveEditedTableEvent: EventEmitter<boolean> = new EventEmitter();
  updateAttributeTableEvent: EventEmitter<boolean> = new EventEmitter();

  openLayersEvent: EventEmitter<boolean> = new EventEmitter();
  openRoisEvent: EventEmitter<boolean> = new EventEmitter();
  openInsertCoordEvent: EventEmitter<boolean> = new EventEmitter();
  openChatEvent: EventEmitter<boolean> = new EventEmitter();
  openLandManageEvent: EventEmitter<boolean> = new EventEmitter();
  openCommentEvent: EventEmitter<boolean> = new EventEmitter();
  openFilterLayerEvent: EventEmitter<any> = new EventEmitter();
  openSearchFeatureEvent: EventEmitter<any> = new EventEmitter();
  openEditModeEvent: EventEmitter<boolean> = new EventEmitter();
  openEditFeatureEvent: EventEmitter<boolean> = new EventEmitter();
  openDeleteFeatureEvent: EventEmitter<boolean> = new EventEmitter();
  openRepositoriesEvent: EventEmitter<any> = new EventEmitter();
  openResumeMuralEvent: EventEmitter<any> = new EventEmitter();
  openDocumentMuralEvent: EventEmitter<any> = new EventEmitter();
  openModalEditFeatureEvent: EventEmitter<any> = new EventEmitter();

  openFilesAppEvent: EventEmitter<boolean> = new EventEmitter();
  openPathsAppEvent: EventEmitter<boolean> = new EventEmitter();

  addLayerEvent: EventEmitter<{
    layer: Layer;
    options?: AddLayerOptions;
  }> = new EventEmitter();
  addLayerOnMapEvent: EventEmitter<{
    layer: Layer;
    options?: AddLayerOptions;
  }> = new EventEmitter();
  removeLayerEvent: EventEmitter<Layer> = new EventEmitter();
  getInfoLayerEvent: EventEmitter<any> = new EventEmitter();
  zoomLayerEvent: EventEmitter<Layer> = new EventEmitter();
  zoomLayerFarmEvent: EventEmitter<any> = new EventEmitter();
  changeLayerVisibilityEvent: EventEmitter<Layer> = new EventEmitter();
  openLayerStyleEvent: EventEmitter<any> = new EventEmitter();
  changeStyleLayerEvent: EventEmitter<any> = new EventEmitter();
  addGetInfoLayerEvent: EventEmitter<any> = new EventEmitter();
  addFeatureToRoiLayerEvent: EventEmitter<any> = new EventEmitter();
  changeLayerFilterEvent: EventEmitter<any> = new EventEmitter();
  changeSearchFeatureEvent: EventEmitter<any> = new EventEmitter();
  addRoiEvent: EventEmitter<any> = new EventEmitter();
  addRoiOnMapEvent: EventEmitter<any> = new EventEmitter();
  deletedRoiOnMapEvent: EventEmitter<any> = new EventEmitter();
  goToCreatedFolderEvent: EventEmitter<string> = new EventEmitter();
  selectedFeatureEvent: EventEmitter<any> = new EventEmitter();
  setOperationManager: EventEmitter<{
    farmName: string,
    feature: any,
    dataLink: any,
    layer: any
  }> = new EventEmitter();
  setOperationSelectedFeature: EventEmitter<{
    feature: any,
    layer: any,
    dataLink: any
  }> = new EventEmitter();
  resetMapSelection: EventEmitter<{any}> = new EventEmitter();

  changeResumeMuralEvent: EventEmitter<any> = new EventEmitter();
  changeDocumentMuralEvent: EventEmitter<any> = new EventEmitter();
  toggleResumesEvent: EventEmitter<boolean> = new EventEmitter();
  toggleDocumentsEvent: EventEmitter<boolean> = new EventEmitter();

  changeLayerOrderEvent: EventEmitter<Layer[]> = new EventEmitter();

  private changeLayerNameSubject = new ReplaySubject<{
    oldName: string;
    newName: string;
  }>(1);
  changeLayerNameEvent = this.changeLayerNameSubject.asObservable();

  private debouncedSimbologyUpdate;

  constructor(private mapService: MapService, private route: ActivatedRoute) {
    this.debouncedSimbologyUpdate = debounce(
      (symbology, db_table, project_id) => {
        const symbologyData: UpdateLayerStyleInterface = {
          table_name: db_table,
          project_id: project_id,
          symbology: symbology,
        };

        this.mapService.updateLayerStyle(symbologyData).subscribe();
      },
      1500
    );
  }

  clearLayerSelection() {
    this.clearLayerSelectionSubject.next();
  }

  changeLayerName(oldName: string, newName: string) {
    this.changeLayerNameSubject.next({
      oldName: oldName,
      newName: newName,
    });
  }

  openLayerTable(layer: Layer, close: boolean | null = null) {
    let confirm_result = false;
    close ? (this.layerTable = false) : (this.layerTable = !this.layerTable);
    this.selectedLayer = layer;

    if (!this.allowEditMode(this.selectedLayer)) {
      this.editMode = false;
      this.openEditModeEvent.emit(false);
    }
    if (!this.layerTable && this.tableChanged) {
      confirm_result = confirm('Você deseja salvar as alterações?');
    }
    console.log(this.layerTable)
    confirm_result
      ? this.saveAttributeTable()
      : this.openLayerTableEvent.emit(this.layerTable);
  }

  openEditMode(layer: Layer) {
    this.selectedLayer = layer;
    this.allowEditMode(this.selectedLayer)
      ? (this.editMode = !this.editMode)
      : (this.editMode = false);
    this.openEditModeEvent.emit(this.editMode);
    !this.editMode && this.layerTable ? this.openLayerTable(layer, true) : null;
  }

  allowEditMode(layer: Layer) {
    let canOpenEditMode: boolean;
    layer.database === 'index'
      ? (canOpenEditMode = false)
      : (canOpenEditMode = true);
    return canOpenEditMode;
  }

  saveAttributeTable() {
    this.saveEditedTableEvent.emit(true);
    this.tableChanged = false;
    this.openLayerTableEvent.emit(false);
  }

  openPanel(panel: string, open: boolean) {
    if (panel == 'layersPanel') {
      this.openLayersPanel(open);
    } else if (panel == 'roisPanel') {
      this.openRoisPanel(open);
    } else if (panel == 'repositoriesPanel') {
      this.openRepositoriesPanel(open);
    } else if (panel == 'insertCoordPanel') {
      this.openInsertCoordPanel(open);
    } else if (panel == 'chatPanel') {
      this.openChatPanel(open);
    } else if (panel == 'landManagePanel') {
      this.openLandManagePanel(open);
    } else if (panel == 'commentPanel') {
      this.openCommentPanel(open);
    } else if (panel == 'resumeMuralPanel') {
      this.toggleResumes(open);
    } else if (panel == 'documentPanel') {
      this.toggleDocuments(open);
    }
    else if (panel == 'filesAppPanel') {
        this.openFilesAppPanel(open);
    }
    else if (panel == 'walksAppPanel') {
        this.openPathsAppPanel(open);
    }
  }

  openPathsAppPanel(open: boolean) {
    this.openPathsAppEvent.emit(open);
  }

  openFilesAppPanel(open: boolean) {
    this.openFilesAppEvent.emit(open);
  }

  openLayersPanel(open: boolean) {
    this.openLayersEvent.emit(open);
  }

  openRoisPanel(open: boolean) {
    this.openRoisEvent.emit(open);
  }

  openRepositoriesPanel(open: boolean) {
    this.openRepositoriesEvent.emit(open);
  }

  openInsertCoordPanel(open: boolean) {
    this.openInsertCoordEvent.emit(open);
  }

  openChatPanel(open: boolean) {
    this.openChatEvent.emit(open);
  }

  openLandManagePanel(open: boolean) {
    this.openLandManageEvent.emit(open);
  }

  openCommentPanel(open: boolean) {
    this.openCommentEvent.emit(open);
  }

  toggleResumes(toggle: boolean) {
    this.toggleResumesEvent.emit(toggle);
  }

  toggleDocuments(toggle: boolean) {
    this.toggleDocumentsEvent.emit(toggle);
  }

  openFilterLayer(layer: Layer) {
    this.selectedLayer = layer;
    this.filterMode = true;
    this.openFilterLayerEvent.emit({
      openFilter: this.filterMode,
      layer: this.selectedLayer,
    });
  }

  openSearchFeature(layer: Layer) {
    this.selectedLayer = layer;
    this.searchFeatureMode = true;
    this.openSearchFeatureEvent.emit({
      openFilter: this.searchFeatureMode,
      layer: this.selectedLayer,
    });
  }

  getLayer(): Layer {
    return this.selectedLayer;
  }

  getEditMode(): boolean {
    return this.editMode;
  }

  addLayer(
    layer: Layer,
    options: AddLayerOptions = {
      autoZoom: true,
      autoSave: true,
    }
  ) {
    this.addLayerEvent.emit({
      layer,
      options,
    });
  }

  openEditFeature(layer: Layer, close: boolean | null = null) {
    this.selectedLayer = layer;
    close ? (this.editFeature = false) : (this.editFeature = !this.editFeature);
    this.openEditFeatureEvent.emit(this.editFeature);
  }

  openDeleteFeature(layer: Layer, close: boolean | null = null) {
    this.selectedLayer = layer;
    close
      ? (this.deleteFeature = false)
      : (this.deleteFeature = !this.deleteFeature);
    this.openDeleteFeatureEvent.emit(this.deleteFeature);
  }

  changeLayerVisibility(layer: Layer) {
    this.changeLayerVisibilityEvent.emit(layer);
  }

  openLayerStyle(layer: Layer) {
    this.selectedLayer = layer;
    this.styleMode = true;
    this.openLayerStyleEvent.emit({
      openStyle: this.styleMode,
      layer: this.selectedLayer,
    });
  }

  changeStyleLayer(layer: Layer, changeType: boolean, project_id?: string) {
    this.selectedLayer = layer;
    this.styleMode = !this.styleMode;
    this.changeStyleLayerEvent.emit({ layer: layer, changeType: changeType });

    if (project_id) {
      this.debouncedSimbologyUpdate(
        layer.symbology,
        layer.db_table,
        project_id
      );
    }
  }

  closeStyleLayer() {
    this.selectedLayer = '';
    if (this.styleMode) this.styleMode = !this.styleMode;
  }
  setMap(mapFrame: Map) {
    this.mapFrame = mapFrame;
  }

  getMap() {
    return this.mapFrame;
  }

  setLayers(layers_list: any) {
    this.layers_list = layers_list;
  }

  getLayers() {
    return this.layers_list;
  }

  addGetInfoLayer(layer: any) {
    this.addGetInfoLayerEvent.emit(layer);
  }

  addSelectedMapFeature(feature: any) {
    this.selectedMapFeature.emit(feature);
  }

  addFeatureToRoiLayer(layer: any) {
    this.addFeatureToRoiLayerEvent.emit(layer);
  }

  changeLayerFilter(layer: Layer, filtersList: any) {
    this.changeLayerFilterEvent.emit({
      layer: layer,
      filtersList: filtersList,
    });
  }

  changeSearchFeature(selectedFeatures: any, zoom: boolean) {
    this.changeSearchFeatureEvent.emit([selectedFeatures, zoom]);
  }
}
